module.exports = __webpack_public_path__ + "img/ascend_gold1.792cb05e.png";